import { useSelector } from "react-redux";
import "./AmSecurityHome.scss";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { IoIosRefresh } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { MdAdd, MdArrowBackIos, MdClose } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoDocumentTextSharp } from "react-icons/io5";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { getCssValue } from "../../../utils/genericFunctions";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";


const AmSecurityHome = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [searchTerm, setSearchTerm] = useState("");
  const [allSecurities, setAllSecurities] = useState([]);
  const [securities, setSecurities] = useState([]);
  const [selectedSecurity, setSelectedSecurity] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: ""
  });
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [currentSecurityPage, setCurrentSecurityPage] = useState(0);
  const [selectedClass, setSelectedClass] = useState(null);
  const [assetClasses, setAssetClasses] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["am-securities"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const location = useLocation();
  const showBack = location.state?.showBack || "N";

  const handleSecurityPageChange = (event, newPage) => {
    setCurrentSecurityPage(newPage);
  };

  const handleSecurityRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 9));
    setCurrentSecurityPage(0);
  };


  const filteredSecurities = securities?.filter(
    (row) =>
      row?.sec_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.sec_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ticker_symbol?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const paginatedSecurities = filteredSecurities?.slice(
    currentSecurityPage * rowsPerPage,
    currentSecurityPage * rowsPerPage + rowsPerPage
  );

  const fetchSecurities = async (firstTime) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      } else {
        setIsProcessing(true);
      }
      const res = await newRequest.post("/amsec/findAll", {
        sec_status: "",
        result_limit: 100
      });
      setAllSecurities(res.data);
      setSecurities(res.data);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessing(false);
    }
  };

  const fetchAssetClasses = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Security Types" });
      const options = [{ _id: "All", sys_code: "All", sys_name: "All", sys_desc: "View all" }, ...res.data];
      setAssetClasses(options);
      setSelectedClass(options[0]);
    } catch (err) {
      console.log(err);
    }
  };


  const handleSearchSecurities = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/amsec/search", { search_input: searchTerm });
        setSecurities(res.data);
      } else {
        fetchSecurities();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSecurities(true);
    fetchAssetClasses();
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openVisit") {

      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  return (
    <div className="securities">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="securities-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="securities-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">{t('securities').toUpperCase()}</div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<IoIosRefresh />} onClick={fetchSecurities}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="none"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  endIcon={<MdAdd />}
                  iconPosition="end"
                  borderRadiusType="right"
                  currentTheme={currentTheme}
                  onClick={() => {
                    try {
                      navigate(`/amsec/new`);
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                >
                  {t('newSecurity')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ display: "flex", width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('security')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchSecurities();
                              }}
                            />
                            {searchTerm.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchSecurities();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm?.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                          <span />
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedSecurities?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedSecurity?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedSecurity(row);
                              navigate(`/amsec/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentSecurityPage * rowsPerPage + index + 1}
                          </TableCell>

                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div className="security-details">
                              {row?.sec_logo_url ? <img src={row?.sec_logo_url} alt="" className='security-avatar' />
                                :
                                <CiImageOn style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%" }} />
                              }
                              <div className="security-name">
                                <span className="name">{row?.sec_name}</span>
                                <span className="code">{row?.sec_code}</span>
                              </div>
                              <div className="security-name">
                                <span className="name">{row?.asset_class_code_xx}</span>
                                <span className="code">{row?.region_code_xx}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "150px", gap: "5px" }}>
                              <span className={`status ${row?.sec_status}`} style={{ width: "0.5px" }} />
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="sub-title">{`${t('currency')} ${row?.base_currency}`}</span>
                                <span className="sub-title xrsmall soft">{row?.listing_status}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.sec_status)}`}>{row?.sec_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {securities?.length > rowsPerPage &&
                    <TablePagination
                      rowsPerPageOptions={[9]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleSecurityRowsPerPage}
                      component="div"
                      count={securities?.length}
                      rows={securities}
                      page={currentSecurityPage}
                      onPageChange={handleSecurityPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="securities-right-wrapper">
            <div className="options-list">
              {assetClasses?.map((row) => (
                <span
                  key={row._id}
                  className={`${selectedClass?._id === row._id
                    ? "single-option active"
                    : "single-option"
                    }`}
                  onClick={async () => {
                    try {
                      setCurrentSecurityPage(0);
                      if (row?.sys_code === "All") {
                        await fetchSecurities();
                      } else {
                        const filteredSecurities = allSecurities.filter(
                          (sec) => sec?.security_type === row?.sys_code
                        );
                        setSecurities(filteredSecurities);
                      }
                      setSelectedClass(row);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <h1 className="sub-title">{row?.sys_name}</h1>
                  <h1 className="sub-title xrsmall soft">{row?.sys_code}</h1>
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docId: "1",
                  docType: "AM Security",
                  format: "xlsx",
                  entity_code: "",
                  date_fm: "",
                  date_to: "",
                  status: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
      />
    </div>
  )
}

export default AmSecurityHome